import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { CONST_URL_SEGEMENTS } from '@fitness-force/constants';
import { AppErrors, NotFoundError } from '@fitness-force/models';;
import type { AppointmentBookingResponse, AppointmentById, AppointmentListResponse, DeleteAppointmentRequest, CancelAppointmentRequest, CreateAppointmentRequest, CreateRecurringAppointmentRequest, CreateResponse, ListAppointmentByClientRequest, ListAppointmentRequest, RescheduleAppointmentRequest, RescheduleRecurringAppointmentRequest, SubstituteCoachRequest, UpdateAppointmentMembership, UpdateAppointmentRequest } from '@fitness-force/models';
import { environment } from '@fitness-force/environments';
import { catchError, map, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppointmentService {
  private http = inject(HttpClient);
  private router = inject(Router);


  BASE_URL: string = environment.BASE_URL;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  
  GetAppointments(appointmentRequest: ListAppointmentRequest): Observable<AppointmentListResponse> {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.SCHEDULING.APPOINTMENT.GET_APPOINTMENTS.replace('{tenant_id}', appointmentRequest.tenant_id.toString());
    let queryParams = new HttpParams()
    .set('start_datetime', appointmentRequest.start_datetime)
    .set('end_datetime', appointmentRequest.end_datetime)
    return this.http.get<ListAppointmentRequest>(url,{headers: this.httpOptions.headers,params:queryParams}).pipe(map((res: any) => {
      if (res) {
        return res;
      }
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  GetAppointment(tenantId:number,apptId:number): Observable<AppointmentById> {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.SCHEDULING.APPOINTMENT.GET_APPOINTMENT.replace('{tenant_id}',tenantId.toString()).replace('{appt_id}', apptId.toString());;
    let queryParam = new HttpParams();
    return this.http.get(url,{headers: this.httpOptions.headers}).pipe(map((res: any) => {
      if (res) {
        return res;
      }
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  CreateAppointment(tenantId:number,createAppointmentRequest: CreateAppointmentRequest): Observable<AppointmentBookingResponse> {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.SCHEDULING.APPOINTMENT.POST_APPOINTMENTS.replace('{tenant_id}', tenantId.toString());
    return this.http.post<CreateAppointmentRequest>(url,createAppointmentRequest,{headers: this.httpOptions.headers}).pipe(map((res: any) => {
      if (res) {
        return res;
      }
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  CreateRecurringAppointment(tenantId:number,createRecurringAppointmentRequest: CreateRecurringAppointmentRequest ): Observable<AppointmentBookingResponse> {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.SCHEDULING.APPOINTMENT.POST_RECURRING_APPOINTMENTS.replace('{tenant_id}', tenantId.toString());
    return this.http.post<CreateRecurringAppointmentRequest>(url,createRecurringAppointmentRequest,{headers: this.httpOptions.headers}).pipe(map((res: any) => {
      if (res) {
        return res;
      }
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  UpdateAppointment(tenantId:number, apptId:number, updateAppointmentRequest: UpdateAppointmentRequest): Observable<CreateResponse> {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.SCHEDULING.APPOINTMENT.PUT_APPOINTMENT.replace('{tenant_id}', tenantId.toString()).replace('{appt_id}', apptId.toString());
    return this.http.put<UpdateAppointmentRequest>(url,updateAppointmentRequest,{headers: this.httpOptions.headers}).pipe(map((res: any) => {
      if (res) {
        return res;
      }
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  RescheduleAppointment(tenantId:number, apptId:number, rescheduleAppointmentRequest: RescheduleAppointmentRequest): Observable<CreateResponse> {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.SCHEDULING.APPOINTMENT.RESCHEDULE_APPOINTMENT.replace('{tenant_id}', tenantId.toString()).replace('{appt_id}', apptId.toString());
    return this.http.post<RescheduleAppointmentRequest>(url,rescheduleAppointmentRequest,{headers: this.httpOptions.headers}).pipe(map((res: any) => {
      if (res) {
        return res;
      }
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  SubstituteCoach(tenantId:number, apptId:number, substituteCoachRequest: SubstituteCoachRequest): Observable<CreateResponse> {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.SCHEDULING.APPOINTMENT.SUBSTITUTE_COACH.replace('{tenant_id}', tenantId.toString()).replace('{appt_id}', apptId.toString());
    return this.http.post<SubstituteCoachRequest>(url,substituteCoachRequest,{headers: this.httpOptions.headers}).pipe(map((res: any) => {
      if (res) {
        return res;
      }
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  
  UpdateRecurringAppointment(tenantId:number, apptTemplateId:number, updateAppointmentRequest: UpdateAppointmentRequest): Observable<CreateResponse> {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.SCHEDULING.APPOINTMENT.PUT_RECURRING_APPOINTMENT.replace('{tenant_id}', tenantId.toString()).replace('{appt_recurring_template_id}', apptTemplateId.toString());
    return this.http.put<UpdateAppointmentRequest>(url,updateAppointmentRequest,{headers: this.httpOptions.headers}).pipe(map((res: any) => {
      if (res) {
        return res;
      }
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  RescheduleRecurringAppointment(tenantId:number, apptTemplateId:number, rescheduleAppointmentRequest: RescheduleRecurringAppointmentRequest): Observable<CreateResponse> {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.SCHEDULING.APPOINTMENT.RESCHEDULE_RECURRING_APPOINTMENT.replace('{tenant_id}', tenantId.toString()).replace('{appt_recurring_template_id}', apptTemplateId.toString());
    return this.http.post<RescheduleRecurringAppointmentRequest>(url,rescheduleAppointmentRequest,{headers: this.httpOptions.headers}).pipe(map((res: any) => {
      if (res) {
        return res;
      }
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  SubstituteCoachInRecurring(tenantId:number, apptTemplateId:number, substituteCoachRequest: SubstituteCoachRequest): Observable<CreateResponse> {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.SCHEDULING.APPOINTMENT.SUBSTITUTE_COACH_RECURRING.replace('{tenant_id}', tenantId.toString()).replace('{appt_recurring_template_id}', apptTemplateId.toString());
    return this.http.post<SubstituteCoachRequest>(url,substituteCoachRequest,{headers: this.httpOptions.headers}).pipe(map((res: any) => {
      if (res) {
        return res;
      }
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  MarkClientCheckIn(tenant_Id:number,appt_id:number): Observable<any> {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.SCHEDULING.APPOINTMENT.MARK_CLIENT_CHECKEDIN.replace('{tenant_id}', tenant_Id.toString()).replace('{appt_id}', appt_id.toString());
    return this.http.post(url,{headers: this.httpOptions.headers}).pipe(map((res: any) => {
      if (res) {
        return res;
      }
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  MarkClientNoShow(tenant_Id:number,appt_id:number): Observable<any> {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.SCHEDULING.APPOINTMENT.MARK_CLIENT_NOSHOW.replace('{tenant_id}', tenant_Id.toString()).replace('{appt_id}', appt_id.toString());
    return this.http.post(url,{headers: this.httpOptions.headers}).pipe(map((res: any) => {
      if (res) {
        return res;
      }
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  CancelAppointment(tenant_Id:number,appt_id:number, cancelRequest:CancelAppointmentRequest): Observable<any> {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.SCHEDULING.APPOINTMENT.CANCEL_APPOINTMENT.replace('{tenant_id}', tenant_Id.toString()).replace('{appt_id}', appt_id.toString());
    return this.http.post(url,cancelRequest,{headers: this.httpOptions.headers}).pipe(map((res: any) => {
      if (res) {
        return res;
      }
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  CancelRecurringAppointment(tenantId:number, apptTemplateId:number, cancelRequest:CancelAppointmentRequest): Observable<any> {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.SCHEDULING.APPOINTMENT.CANCEL_RECURRING_APPOINTMENT.replace('{tenant_id}', tenantId.toString()).replace('{appt_recurring_template_id}', apptTemplateId.toString());
    return this.http.post(url,cancelRequest,{headers: this.httpOptions.headers}).pipe(map((res: any) => {
      if (res) {
        return res;
      }
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  DeleteAppointment(tenant_Id:number,appt_id:number): Observable<any> {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.SCHEDULING.APPOINTMENT.DELETE_APPOINTMENT.replace('{tenant_id}', tenant_Id.toString()).replace('{appt_id}', appt_id.toString());
    return this.http.delete(url,{headers: this.httpOptions.headers}).pipe(map((res: any) => {
      if (res) {
        return res;
      }
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  DeleteRecurringAppointment(tenantId:number, apptTemplateId:number, deleteRequest:DeleteAppointmentRequest): Observable<any> {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.SCHEDULING.APPOINTMENT.DELETE_RECURRING_APPOINTMENT.replace('{tenant_id}', tenantId.toString()).replace('{appt_recurring_template_id}', apptTemplateId.toString());
    const options = {
      headers: this.httpOptions.headers,
      body: deleteRequest
    };
    return this.http.delete(url,options).pipe(map((res: any) => {
      if (res) {
        return res;
      }
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  UpdateClientmembership(tenantId:number,appointmentId: number,updateApppointmentBooking:UpdateAppointmentMembership): Observable<any> {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.SCHEDULING.APPOINTMENT.UPDATE_APPOINTMENT_CLIENT_MEMBERSHIP.replace('{tenant_id}', tenantId.toString()).replace('{appt_id}', appointmentId.toString());
    return this.http.put<UpdateAppointmentMembership>(url,updateApppointmentBooking,{headers: this.httpOptions.headers}).pipe(map((res: any) => {
      if (res) {
        return res;
      }
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  GetAppointmentsByClient(appointmentRequest: ListAppointmentByClientRequest): Observable<AppointmentListResponse> {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.SCHEDULING.APPOINTMENT.GET_APPOINTMENTS_CLIENT.replace('{tenant_id}', appointmentRequest.tenant_id.toString())
    .replace('{client_id}', appointmentRequest.client_id.toString());
    let queryParams = new HttpParams()
    .set('start_datetime', appointmentRequest.start_datetime)
    .set('end_datetime', appointmentRequest.end_datetime)
    return this.http.get<ListAppointmentRequest>(url,{headers: this.httpOptions.headers,params:queryParams}).pipe(map((res: any) => {
        return res;
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

  MarkComplimentoryAppointment(tenant_Id:number,client_id:number,appt_id:number, compRequest:any): Observable<any> {
    const url = this.BASE_URL + CONST_URL_SEGEMENTS.SCHEDULING.APPOINTMENT.MARK_COMPLIMENTORY_APPOINTMENT.replace('{tenant_id}', tenant_Id.toString()).replace('{client_id}', client_id.toString()).replace('{appt_id}', appt_id.toString());
    return this.http.post(url,compRequest,{headers: this.httpOptions.headers}).pipe(map((res: any) => {
     return res;
    }), catchError((error: Response) => {
      if (error.status === 404) {
        return throwError(() => new NotFoundError(error));
      }
      return throwError(() => new AppErrors(error));
    }));
  }

}
